<script setup lang="ts">
import { computed } from "vue";
import { availabilityColor } from "./availabilityColor";

const props = defineProps<{
	fillRate: number | null;
}>();

const fill = computed(() =>
	props.fillRate !== null ? Math.max(0, Math.min(100, props.fillRate)) : null
);

const remaining = computed(() => (fill.value !== null ? 100 - fill.value : null));

const fillColor = computed(() => availabilityColor(fill.value !== null ? 100 - fill.value : null));

</script>

<template>
	<div v-if="fill !== null" class="frb">
		<div class="frb__bar">
			<div
				class="frb__segment frb__segment--fill"
				:style="{ width: fill + '%', background: fillColor }"
			/>
			<div
				class="frb__segment frb__segment--remaining"
				:style="{ width: remaining + '%' }"
			/>
		</div>
		<div class="frb__labels">
			<span class="frb__label frb__label--fill">
				{{ fill.toFixed(1) }}% Fill rate
			</span>
			<span class="frb__label frb__label--remaining">
				{{ remaining!.toFixed(1) }}% Remaining
			</span>
		</div>
	</div>
	<div v-else class="frb__no-data">No data available</div>
</template>

<style scoped>
.frb {
	display: flex;
	flex-direction: column;
	gap: 5px;
	margin-top: 8px;
}

.frb__bar {
	display: flex;
	height: 8px;
	border-radius: 4px;
	overflow: hidden;
	background: rgba(255, 255, 255, 0.1);
}

.frb__segment {
	height: 100%;
	transition: width 0.2s ease;
}

.frb__segment--remaining {
	background: rgba(255, 255, 255, 0.2);
}

.frb__labels {
	display: flex;
	justify-content: space-between;
}

.frb__label {
	font-size: 0.7rem;
	font-weight: 600;
}

.frb__label--fill {
	color: rgba(255, 255, 255, 0.5);
}

.frb__label--remaining {
	color: rgba(255, 255, 255, 0.5);
}

.frb__no-data {
	font-size: 0.7rem;
	color: rgba(255, 255, 255, 0.4);
	margin-top: 8px;
}
</style>
